import type { ReactNode } from "react";

export type Props = {
  title: ReactNode;
  eyebrow?: string;
  /** Reduces top spacing when rendered below a Breadcrumb */
  compact?: boolean;
  /** Overrides the default top padding wrapper classes. */
  containerClassName?: string;
  /** Overrides the default title typography classes. */
  titleClassName?: string;
};

/**
 * PageHeading displays a top-level page title.
 *
 * For interior/detail pages that need a back link, use the Breadcrumb
 * component above the PageHeading instead.
 */
export default function PageHeading({ title, eyebrow, compact, containerClassName, titleClassName }: Props) {
  const defaultContainerClassName = compact ? "pt-8 sm:pt-4" : "pt-8";
  const defaultTitleClassName = "text-sys-on-surface text-headline-large-bold font-serif";

  return (
    <div className={containerClassName ?? defaultContainerClassName} data-testid="page-heading">
      {eyebrow ? (
        <p
          className="mb-2 text-label-medium uppercase tracking-widest text-sys-brand-on-surface-variant"
          data-testid="page-heading-eyebrow"
        >
          {eyebrow}
        </p>
      ) : null}
      <h1 className={titleClassName ?? defaultTitleClassName} data-testid="nav-header">
        {title}
      </h1>
    </div>
  );
}
